import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../../auth/auth.service';

@Component({
  selector: 'app-illustration',
  templateUrl: './illustration.component.html',
  styleUrls: ['./illustration.component.scss']
})
export class IllustrationComponent implements OnInit {
 slide = 0;
  constructor(private router: Router,
              private authService: AuthService) { }

  navigateToStart() {
    this.authService.didFirstLogin()
      .subscribe((response) => {});
    this.router.navigate(['intro/start']);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/intro-wizard/illustration/illustration.component.ts